import { type ReactNode } from 'react';

import {
  usePermissionCheck,
  type PermissionCheckOptions,
} from '@/hooks/usePermissionCheck';

type PermissionCheckProps = PermissionCheckOptions & {
  children: ReactNode;
  /** Rendered instead of the children when the permission is missing. */
  fallback?: ReactNode;
};

/**
 * Renders its children only when the signed-in user holds the requested
 * permissions in the current scope.
 *
 * ```tsx
 * <PermissionCheck oneOf={[Permissions.items.edit, Permissions.items.create]}>
 *   <EditButton />
 * </PermissionCheck>
 * ```
 */
export const PermissionCheck = ({
  children,
  fallback = null,
  ...check
}: PermissionCheckProps) => (usePermissionCheck(check) ? children : fallback);
